
















































































































































import {
  Vue, Component, Prop, Emit, Watch,
} from 'vue-property-decorator';
import RuleScript from '@/domain/scripts/entity/rule-script.entity';
import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css';
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism-tomorrow.css';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import RuleHistoryService from '@/domain/scripts/service/rule-history.service';
import RuleHistoryDetail from '@/domain/scripts/entity/rule-history-detail.entity';
import RuleScriptParameter from '@/domain/scripts/entity/rule-script-parameter.entity';
import { diffLines, DiffLine } from '@/domain/scripts/line-diff';
import ParameterTypes from './parameter-type.json';

function parameterTypeDescription(type: string): string {
  const found = ParameterTypes.find((item) => item.value === type);
  return found ? found.description : type;
}

function parameterLine(parameter: RuleScriptParameter): string {
  return `${parameter.name} · ${parameterTypeDescription(parameter.type)}`;
}

function sortedParameterLines(parameters: RuleScriptParameter[]): string[] {
  return [...parameters]
    .sort((a, b) => a.name.localeCompare(b.name))
    .map(parameterLine);
}

@Component({
  components: {
    PrismEditor,
  },
})
export default class ScriptContent extends Vue {
  @Prop({
    required: true,
  })
  script!: string;

  @Prop({
    required: true,
  })
  businessUnitId!: string;

  @Prop({
    required: true,
    default: false,
  })
  previewModeValue!: boolean;

  @Prop() ruleId?: string;

  @Prop() currentVersion?: number | null;

  @Prop({ default: false }) showVersionChip!: boolean;

  @Prop({ default: false }) editingFromVersion!: boolean;

  @Prop({ default: '' }) versionIndicatorText!: string;

  @Prop({ default: () => [] }) parameters!: RuleScriptParameter[];

  ref: any = this.$refs;

  ruleToEdit: RuleScript = RuleScript.of({});

  code = '';

  showHelp: boolean = false;

  showCompare: boolean = false;

  loadingCompare: boolean = false;

  publishedScript: string = '';

  publishedParameters: RuleScriptParameter[] = [];

  @Watch('script')
  onScriptChange() {
    if (this.script !== undefined && this.script !== this.ruleToEdit.script) {
      this.ruleToEdit.script = this.script;
    }
  }

  created() {
    if (this.script) {
      this.ruleToEdit.script = this.script;
      this.updateScript();
    }
  }

  updateScript() {
    this.$emit('script', this.ruleToEdit.script)
  }

  highlighter(code: string) {
    return highlight(code, languages.js);
  }

  copyScript(): void {
    navigator.clipboard.writeText(this.ruleToEdit.script)
      .then(() => VbSnackbarService.showSuccess('Script copiado para a área de transferência'))
      .catch(() => VbSnackbarService.showError('Não foi possível copiar o script'));
  }

  openCompare() {
    if (this.publishedScript) {
      this.showCompare = true;
      return;
    }
    this.loadPublishedScript();
  }

  loadPublishedScript() {
    if (!this.ruleId || !this.currentVersion) return;
    this.loadingCompare = true;
    this.showCompare = true;
    RuleHistoryService.getHistoryVersion(
      this.businessUnitId, this.ruleId, String(this.currentVersion),
    )
      .then((detail: RuleHistoryDetail) => {
        this.publishedScript = detail.script;
        this.publishedParameters = detail.parameters;
      })
      .catch((err: any) => {
        this.showCompare = false;
        VbSnackbarService.handleHttpError(err);
      })
      .finally(() => { this.loadingCompare = false; });
  }

  get scriptCompareLines(): DiffLine[] {
    return diffLines(this.publishedScript.split('\n'), this.ruleToEdit.script.split('\n'));
  }

  get hasScriptChanges(): boolean {
    return this.scriptCompareLines.some((line) => line.type !== 'CONTEXT');
  }

  get parameterCompareLines(): DiffLine[] {
    const from = sortedParameterLines(this.publishedParameters);
    const to = sortedParameterLines(this.parameters);
    return diffLines(from, to);
  }

  get hasParameterChanges(): boolean {
    return this.parameterCompareLines.some((line) => line.type !== 'CONTEXT');
  }

  marker(line: DiffLine): string {
    if (line.type === 'ADD') return '+';
    if (line.type === 'DEL') return '-';
    return ' ';
  }
}
